// src/modules/app-views/products/pages/Document/components/ProductsDocumentCardHeaderColumn3.jsx
// *******************************************************************************
// CARD HEADER COLUMN 3 - Stock (Physical / Reserved / Available)
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleColumn from 'components/SimpleComponents/SimpleColumn';
import { InboxOutlined, LockOutlined, CheckCircleOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
export const ProductsDocumentCardHeaderColumn3 = ({ ...record }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const physicalStock = record?.stock?.quantity || 0;
  const reserved = record?.stock?.reservedQuantity || 0;
  const available = physicalStock - reserved;

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  const items = [
    {
      key: 'physicalStock',
      icon: <InboxOutlined />,
      label: String(physicalStock),
      tooltipText: translateX('physical_stock'),
      tooltipPlacement: 'right',
    },
    {
      key: 'reserved',
      icon: <LockOutlined />,
      label: String(reserved),
      tooltipText: translateX('reserved'),
      tooltipPlacement: 'right',
    },
    {
      key: 'available',
      icon: <CheckCircleOutlined />,
      label: String(available),
      tooltipText: translateX('available'),
      tooltipPlacement: 'right',
    },
  ];

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return <SimpleColumn items={items} />;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ProductsDocumentCardHeaderColumn3;
